// removed by extract-text-webpack-plugin
module.exports = {"component":"_1cAk5inSB0VHzgB7BtSA73","topTitle":"_3iykL-W3J7urHG0aaSo6pW","orderStatus":"_1y8L_9UPCwPACx_xLYM9s3","xiola":"_3YiRlesdgdGVfZpA8i0w1h","xiolb":"_3UU_n96UDqJZ1tqkMe0iiX","xiolc":"_3ihG2ilEfMGVkZQOHNLMiK","newPage":"zkEjRniLsgVQfJsLAZYsz","pageTopTitle":"_3ub8BwYVYDkkL4-xZsH4va","linka":"_1DbyAlNX-DHj9GUzKRtrpW","serviceEvaluate":"_1J5pJkximQJ4jNcWD1ODDi","tip":"_3aR7SLvx3jcu8g4r7ZEmNV","serviceTip":"_3W0_lUoQJhA8vKUuaZyIlk","linkBtn":"oGiXQ_JOLoeWOiHnGD0Nk","btn":"cUhZeDSG3FSbtUeZUz-vh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceOrderEvaluateComponent/ServiceOrderEvaluateComponent.scss
 ** module id = 1031
 ** module chunks = 0
 **/